<template>
    <div class="relative">
        <background />
        <container>
            <h2> Our Pipeline: </h2>
            <row :justify="'around'" :align="'center'">
                <column :width="2/5" v-for="(section, index) in sections" :key="index">
                    <component :is="section.image"  />
                    <h4 class="text-outline">{{section.title}}</h4>
                    <p class="text-outline">{{section.text}}</p>
                </column>
            </row>
        </container>
        <spacer />
    </div>
</template>

<script>
import {pipeline} from '../../assets';
export default {
    data() {
        return {
            sections: pipeline.sections
        }
    },
    components: pipeline.components
}
</script>

<style scoped>
    .column {
        position: relative;
        margin: 1em;
    }
    .column > svg {
		position: absolute;
		height: 100%;
		left: 50%;
		transform:translateX(-50%);
		fill: rgba(85, 85, 85, 0.5);
		z-index: -1;
	}
    .background {
        background-image: url('../../assets/background/circuits.jpg');
    }
</style>